import { Option } from 'shared/components/Select/models/Option';
import { mapBuildingGatesTypeLabel } from 'shared/constants/filters/mapBuildingGatesTypeLabel';
import { EBuildingGatesType } from 'shared/types/filters/advanced/buildingGatesType';

export const buildingGatesTypeOptions = [
  new Option(EBuildingGatesType.Dock, mapBuildingGatesTypeLabel[EBuildingGatesType.Dock]),
  new Option(EBuildingGatesType.Ground, mapBuildingGatesTypeLabel[EBuildingGatesType.Ground]),
  new Option(EBuildingGatesType.Ramp, mapBuildingGatesTypeLabel[EBuildingGatesType.Ramp]),
];
